'use strict';
const angular = require('angular');

/*@ngInject*/
export function IntegrationService($resource) {
  return $resource('/api/integrations/:id', {
    id: '@_id'
  },{
    test: {
      method: 'GET',
      url: "/api/integrations/test"
    },
    queryResidentDirectory: {
      method: 'GET',
      url: "/api/integrations/resident-directory",
      isArray: true
    },
    queryServiceRequestsByUser: {
      method: 'GET',
      url: "/api/integrations/servicerequests/:email",
      isArray: true
    },
    queryServiceRequestCodes: {
      method: 'GET',
      url: "/api/integrations/servicerequests/codes",
      isArray: true
    },
    saveServiceRequest: {
      method: 'POST',
      url: "/api/integrations/servicerequests"
    },
    deleteServiceRequest: {
      method: 'DELETE',
      url: "/api/integrations/servicerequests/:id"
    },
    patchServiceRequest: {
      method: 'PATCH',
      url: "/api/integrations/servicerequests/:id"
    }
  });
}


export default angular.module('conduuApp.IntegrationService', [])
  .factory('IntegrationService', IntegrationService)
  .name;



// WEBPACK FOOTER //
// ./client/services/integration/integration.service.js